/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ForYouScoreType = {
    Personalized: 'personalized',
    Traveler: 'traveler'
} as const;
export type ForYouScoreType = typeof ForYouScoreType[keyof typeof ForYouScoreType];


export function instanceOfForYouScoreType(value: any): boolean {
    for (const key in ForYouScoreType) {
        if (Object.prototype.hasOwnProperty.call(ForYouScoreType, key)) {
            if (ForYouScoreType[key as keyof typeof ForYouScoreType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ForYouScoreTypeFromJSON(json: any): ForYouScoreType {
    return ForYouScoreTypeFromJSONTyped(json, false);
}

export function ForYouScoreTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForYouScoreType {
    return json as ForYouScoreType;
}

export function ForYouScoreTypeToJSON(value?: ForYouScoreType | null): any {
    return value as any;
}

export function ForYouScoreTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ForYouScoreType {
    return value as ForYouScoreType;
}

